import CanadaFlag from '@src/common/assets/canada-flag-icon.svg?react';
import UsaFlag from '@src/common/assets/usa-flag-icon.svg?react';
import { Divider } from '@src/common/components/Divider';
import { Stack } from '@src/common/components/Stack';
import { Typography } from '@src/common/components/Typography';
import { theme } from '@src/common/styles/Theme';
import type { PermitInstruction } from '@src/orders/domain/PermitInstruction';
import { Country } from '@src/orders/domain/PermitInstruction';

type Props = { instructions: PermitInstruction[] };

export const PermitsInstructionsSection = (props: Props) => {
  if (props.instructions.length <= 0) {
    return null;
  }

  return (
    <Stack gap={theme.spacing['3']}>
      {props.instructions.map((instruction, index) => (
        <PermitInstructionDetail
          key={`permit-instruction-${index}`}
          instruction={instruction}
        />
      ))}
    </Stack>
  );
};

type InstructionProps = {
  instruction: PermitInstruction;
};

const PermitInstructionDetail = ({ instruction }: InstructionProps) => {
  const flag =
    instruction.country === Country.CANADA ? <CanadaFlag /> : <UsaFlag />;

  return (
    <Stack
      bgcolor={theme.palette.surface.surfaceContainerLowest}
      borderRadius="12px"
      height="fit-content"
      paddingX={theme.spacing['7']}
      paddingY={theme.spacing['9']}
    >
      <Stack direction="row" gap={theme.spacing['3']}>
        {flag}
        <Typography style={theme.typography.body.large}>
          {instruction.jurisdiction}
        </Typography>
        <Typography style={theme.typography.label.large}>
          {instruction.permitName}
        </Typography>
        <Typography style={theme.typography.body.large}>
          {instruction.permitType}
        </Typography>
      </Stack>
      <Divider style={{ paddingTop: theme.spacing['2'] }} />
      <Stack paddingTop={theme.spacing['6']}>
        <Typography style={theme.typography.body.large}>
          {instruction.text}
        </Typography>
      </Stack>
    </Stack>
  );
};
